// Pure, isolated card-lighting evaluator for the Active groups page.
//
// It decides whether a Section's card should light up, given the Section's live signals. An active
// Alarm is the only signal that lights a card; every other Section stays completely quiet
// (`level: 'none'`). Growth Index, Dynamic Mortality and Water Index deliberately do not
// participate — each is read from the row's own column or gauge, which carries its own colouring.
//
// The flag is deliberately named `needsAttention`, NEVER `deviation`: this is an informal,
// hardcoded attention heuristic, distinct from the formal, Objective-based Deviation concept
// (see CONTEXT.md).
//
// This module is pure and has no Vue/store dependencies so it can be unit-tested in isolation if
// the surface graduates from preview.

export type SectionSignals = {
    // True when the API returned at least one active (unresolved, within 48h) Alarm on this Section.
    hasAlarms: boolean;
    isEmpty: boolean;
};

export type AttentionLevel = 'none' | 'red';

// Ranks the attention levels so they can be compared (ordering in the sort module).
export const ATTENTION_SEVERITY: Record<AttentionLevel, number> = { none: 0, red: 1 };

export function needsAttention(signals: SectionSignals): AttentionLevel {
    // Empty Sections (no pigs) are muted: they never colour, even while carrying an active Alarm.
    // The Alder column's alarm chip still renders on such a row, so the Alarm is never hidden.
    if (signals.isEmpty) {
        return 'none';
    }

    return signals.hasAlarms ? 'red' : 'none';
}
